export enum MessengerSendMessageSendingStatus {
  Pending = 1,
  Succeeded = 2,
  BlacklistedByProvider = 3,
  Failed = 4,
}
